
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getAgentProduct } from '@/api/product/product'
import { setAgentProduct } from '@/api/merchant/product'
import subProduct from './subFeeInfo.vue'

@Component({
  name: 'sub-product-fee-info',
  components: {
    subProduct
  }
})
export default class extends Vue {
  @Prop({ required: true }) subInfo!: any
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) merchantProductId!: string

  private back() {
    this.$emit('close', false)
  }

  private loading: boolean = false

  private infoForm: any = {
    extra_param: {
      product_sub_switch: 0,
      product_sub_rate_list: [
        {
          product_sub_code: '',
          rate_list: []
        }
      ]
    }
  }

  private currentProduct: any = []

  private activeNames: string | number = ''

  // 获取产品列表
  private async getProductlistData() {
    const data = {
      id: this.subInfo.id
    }
    await getAgentProduct(data).then((res: any) => {
      this.infoForm = res
    })
  }

  private async submitData() {
    try {
      this.loading = true
      const data = {
        merchant_no: this.merchant_no,
        id: this.infoForm.id,
        extra_param: {
          product_sub_switch: this.infoForm.extra_param.product_sub_switch,
          product_sub_rate_list: this.infoForm.extra_param.product_sub_rate_list
        }
      }
      await setAgentProduct(data).then((res: any) => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.loading = false
        this.back()
      })
    } catch (error) {
      this.loading = false
    }
  }

  private async init() {
    await this.getProductlistData()
  }

  mounted() {
    this.init()
  }
}
